import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialStateWorkloadStd, IWorkloadStdPayload } from "../types";
import { GetDeleteWorkloadStd, GetWorkloadStd } from "./thunk";

const initialState: IInitialStateWorkloadStd = {
    workloadStd: [],
    selectedWorkloadStdIDs: [],
    WorkloadStdRestore: [],
    isLoadingWorkloadStd: true,
    isViewRestoreWorkloadStd: false,
};

const workloadStdSlice = createSlice({
    name: "workloadStandards",
    initialState,
    reducers: {
        setWorkloadStd: (state, action) => {
            state.workloadStd = action.payload;
        },
        setIsViewRestoreWorkloadStd: state => {
            state.isViewRestoreWorkloadStd = !state.isViewRestoreWorkloadStd;
        },
        deletedRestoreWorkloadStd: (state, action) => {
            state.WorkloadStdRestore = state.WorkloadStdRestore.filter(elem => elem.id !== action.payload);
        },
        deleteWorkloadStd: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.workloadStd = state.workloadStd.filter(elem => elem.id !== id);
        },
        updateWorkloadStd: (state, action: PayloadAction<IWorkloadStdPayload>) => {
            const updateData = action.payload;

            state.workloadStd = state.workloadStd.map(elem => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },

        setSelectedWorkloadStdIDs: (state, action) => {
            state.selectedWorkloadStdIDs = action.payload;
        },
        setWorkloadStdRestore: (state, action) => {
            state.WorkloadStdRestore = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetWorkloadStd.pending, state => {
                state.isLoadingWorkloadStd = true;
            })
            .addCase(GetWorkloadStd.fulfilled, state => {
                state.isLoadingWorkloadStd = false;
            })
            .addCase(GetWorkloadStd.rejected, state => {
                state.isLoadingWorkloadStd = false;
            })
            .addCase(GetDeleteWorkloadStd.pending, state => {
                state.isLoadingWorkloadStd = true;
            })
            .addCase(GetDeleteWorkloadStd.fulfilled, state => {
                state.isLoadingWorkloadStd = false;
            })
            .addCase(GetDeleteWorkloadStd.rejected, state => {
                state.isLoadingWorkloadStd = false;
            });
    },
});

export const {
    setIsViewRestoreWorkloadStd,
    setSelectedWorkloadStdIDs,
    deletedRestoreWorkloadStd,
    setWorkloadStd,
    setWorkloadStdRestore,
    updateWorkloadStd,
    deleteWorkloadStd,
} = workloadStdSlice.actions;

export default workloadStdSlice;
